import GLightbox from 'glightbox'

export default () => {

    $('.js-glightbox-category').each(function (key, val) {

        window['myGallery' + key] = GLightbox({
            selector: '.js-glightbox-' + val.getAttribute('data-id'),
            videosWidth: 1365
        });

        $(this).on("click", function(e) {

            e.preventDefault();
            window['myGallery' + key].open();

        });

    });

}
